import { useTranslation } from '@/shared/i18n/use-translation';
import { SidebarTrigger } from '@/shared/ui/sidebar/sidebar-trigger';
import { HeaderBreadcrumb } from './header-breadcrumb';
import { LocaleMenu } from './locale-menu';
import { ThemeMenu } from './theme-menu';

/** Desktop: toggle the sidebar (⌘B), where you are, and the theme and language on the right. */
export function AppHeader() {
  const { t } = useTranslation();
  return (
    <header className="hidden h-12 shrink-0 items-center gap-2 pr-3 pl-2 md:flex">
      <SidebarTrigger aria-label={t('Toggle the sidebar')} title={t('Toggle the sidebar (⌘B)')} />
      <HeaderBreadcrumb />
      <div className="ml-auto flex items-center gap-1">
        <ThemeMenu />
        <LocaleMenu />
      </div>
    </header>
  );
}
